<template>
  <div>
    <div>
      <div style="background-color: white">
        <van-cell title="漏发通知详情" size="large" icon="arrow-left" @click="onClick"/>
      </div>
    </div>
    <div>
        <van-cell-group border>
          <van-cell title="医药药品名称" label="">
            <template #extra>
              漏发数量
            </template>
            <template #default>
              <span style="float: left;color: #383233">单位</span>
            </template>
          </van-cell>
          <div style="border-bottom: solid #F5F6F7 1px" v-for="(item,index) in orderLost.list" :key="index">
            <van-cell :label="item.drugCode" center>
              <template #title border>
                <span style="width: 50px">{{ item.drugName }}</span>
              </template>
              <template #extra>
                <span style="margin-right: 20px">{{ item.qty }}</span>
              </template>
              <template #default>
                <span style="float: left;color: #383233">{{ item.unit }}</span>
              </template>
            </van-cell>
          </div>
        </van-cell-group>
    </div>
    <div style="margin-top: 10px">
      <van-cell-group>
        <van-cell class="van-cell" title="申请单位" :value="orderLost.orgName"/>
        <van-cell title="漏发品种数" :value="orderLost.drugNumber"/>
        <van-cell title="漏发总数量" :value="orderLost.totalNumber"/>
        <van-cell title="验收时间" :value="orderLost.createTime"/>
        <van-cell title="验收人员" :value="orderLost.createBy"/>
        <van-cell title="订单装箱号"  :value="orderLost.packageNo"/>
        <van-cell title="发货单号" :value="orderLost.distributionNo"/>
        <van-cell title="漏发告知单号" :value="orderLost.lostNo"/>
      </van-cell-group>
    </div>
  </div>

</template>

<script>
import api from "@/axios/api";
import {mapGetters, mapActions} from "vuex";

export default {
  name: "orderLostItems",
  computed: {
    ...mapGetters(["token"])
  },
  watch: {
    token: {
      immediate: true,
      handler: function(val) {
        this.lostNo = this.$route.query.lostNo;
        //this.initDrugInfo();
        if (val) {
          this.initDrugInfo();
        }
      }
    }
  },
  data() {
    return {
      active: 0,
      lostNo:'',
      orderLost : [],
      step:[]
    }
  },
  mounted(){
    this.lostNo = this.$route.query.lostNo;
  },
  methods:{
    //页面初始化时加载数据方法
    initDrugInfo(){
      let params = {
        lostNo:this.lostNo
      }

      api.getOrderLostByLostNo(params).then((res) => {
        if (res.success){
          this.orderLost = res.result;
        }
      })
    },
    onClick(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
.g-hd {
  display: inline;
  float: left;
  font-size: 20px;
  font-weight: lighter;
  font-style: normal;
  background-color: white;
  margin-left: 3%;
  overflow: hidden;
}

.van-cell__title {
  text-align: left;
}

.van-cell--large{
  padding-left: 0px;
}


</style>



// WEBPACK FOOTER //
// src/spd/lost/orderLostItems.vue